// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ_CONTACT_BUY_IN_eshop = "Kup na %(eshop)s";
export const BZ_CONTACT_CALL_phone = "Zavolej na %(phone)s";
export const BZ_CONTACT_CALL_phone_OR_BUY_IN_eshop = "Zavolej na %(phone)s nebo kup na %(eshop)s";
export const BZ_CONTACT_OR_BUY_IN_eshop = "nebo kup na %(eshop)s";
export const BZ_CONTACT_OR_CALL_phone = "nebo zavolej na %(phone)s";
export const BZ_CONTACT_OR_CALL_phone_AND_BUY_IN_eshop = "nebo zavolej na %(phone)s a kup na %(eshop)s";
